import styled from 'styled-components';
import { RadioGroup } from '@app/components/common/Radio/Radio';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const ContentQuestion = styled.div`
  margin-bottom: 24px;
`;

export const RadioGroupStyle = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .ant-radio-wrapper {
    color: #333;
  }
  .ant-radio-inner {
    background: #fff;
  }
`;
